const openCollapses = new Set<string>();
const openNestedCollapses = new Set<string>();

export function getOpenCollapses(seed?: string | null): string[] {
  if (seed) openCollapses.add(seed);
  return Array.from(openCollapses);
}

export function ensureOpenCollapse(key: string): string[] {
  openCollapses.add(key);
  return Array.from(openCollapses);
}

export function toggleOpenCollapse(key: string): string[] {
  if (openCollapses.has(key)) openCollapses.delete(key);
  else openCollapses.add(key);
  return Array.from(openCollapses);
}

export function getOpenNestedCollapses(seed?: string | null): string[] {
  if (seed) openNestedCollapses.add(seed);
  return Array.from(openNestedCollapses);
}

export function ensureOpenNestedCollapse(key: string): string[] {
  openNestedCollapses.add(key);
  return Array.from(openNestedCollapses);
}

export function toggleOpenNestedCollapse(key: string): string[] {
  if (openNestedCollapses.has(key)) openNestedCollapses.delete(key);
  else openNestedCollapses.add(key);
  return Array.from(openNestedCollapses);
}
